import moment from 'moment-timezone';

import { TimeFrameLabelValues } from '../time-frame-label-values.model';
import { TimeFrameLabels } from '../time-frame-labels.enum';

const formats = {
  monthAndYear: 'MMMM YYYY',
  year: 'YYYY',
};

export const DateRangeFormatters = {
  [TimeFrameLabelValues[TimeFrameLabels.AllTime]]: () => TimeFrameLabels.AllTime,
  [TimeFrameLabelValues[TimeFrameLabels.CurrentWeek]]: () => TimeFrameLabels.CurrentWeek,
  [TimeFrameLabelValues[TimeFrameLabels.CurrentYear]]: () => moment().format(formats.year),
  [TimeFrameLabelValues[TimeFrameLabels.CurrentMonth]]: () => moment().format(formats.monthAndYear),
  [TimeFrameLabelValues[TimeFrameLabels.CurrentQuarter]]: () =>
    `${moment().startOf('quarter').format(formats.monthAndYear)} - ${moment()
      .endOf('quarter')
      .format(formats.monthAndYear)}`,
  [TimeFrameLabelValues[TimeFrameLabels.LastWeek]]: () => TimeFrameLabels.LastWeek,
  [TimeFrameLabelValues[TimeFrameLabels.LastMonth]]: () =>
    moment().subtract(1, 'month').format(formats.monthAndYear),
  [TimeFrameLabelValues[TimeFrameLabels.LastQuarter]]: () =>
    `${moment().subtract(1, 'quarter').startOf('quarter').format(formats.monthAndYear)} - ${moment()
      .subtract(1, 'quarter')
      .endOf('quarter')
      .format(formats.monthAndYear)}`,
  [TimeFrameLabelValues[TimeFrameLabels.LastYear]]: () => moment().subtract(1, 'years').format(formats.year),
};
